import Journey from '@models/Journey'

export const getJourneysByDirections = (directions) => {
  return Journey.query()
    .withAll()
    .where((journey) => directions.includes(journey.direction))
    .get()
}

export const getJourneysBespokeByDirections = (directions) => {
  return Journey.query()
    .withAll()
    .where((journey) => journey.bespoke)
    .where((journey) => directions.includes(journey.direction))
    .get()
}

export const getJourneysExtraByDirections = (directions) => {
  return Journey.query()
    .withAll()
    .where((journey) => journey.extraJourney)
    .where((journey) => directions.includes(journey.direction))
    .get()
}

export const getJourneysWithLegsByDirections = (directions) => {
  return Journey.query()
    .with('legs')
    .where((journey) => directions.includes(journey.direction))
    .get()
}

export const getJourneysWithLegsAndIdsByDirection = (
  direction,
  currentJourneyId,
  journeyId
) => {
  return Journey.query()
    .with('legs')
    .where(
      (journey) =>
        direction === journey.direction &&
        ![currentJourneyId, journeyId].includes(journey.id)
    )
    .get()
}

export const getNewJourneysWithLegsByDirections = (directions) => {
  return Journey.query()
    .with('legs')
    .where(
      (journey) =>
        directions.includes(journey.direction) &&
        journey.active_journey_id === '' &&
        journey.parent_journey_id === ''
    )
    .get()
}

export const getActiveJourneysWithLegsByDirections = (directions) => {
  return Journey.query()
    .with('legs')
    .where(
      (journey) =>
        directions.includes(journey.direction) &&
        journey.active_journey_id === ''
    )
    .get()
}

export const getSavedJourneysByDirections = (directions) => {
  return Journey.query()
    .where((journey) => directions.includes(journey.direction))
    .where((journey) => journey.active_journey_id === '')
    .where((journey) => !journey.replanned)
    .get()
}

export const getReplannedJourneysByDirections = (directions) => {
  return Journey.query()
    .where((journey) => directions.includes(journey.direction))
    .where((journey) => journey.active_journey_id === '')
    .where((journey) => journey.replanned)
    .get()
}
